import { SwitchLineInput } from '@sequencehq/core-components'

import { GreyGrey80, Primary13Regular } from '@sequencehq/core-components'
import { RateDisplay } from 'Invoices/types'

type Props = {
  rateDisplay: RateDisplay
  setRateDisplay: (display: RateDisplay) => void
}

export const PercentageRatesToggle = ({
  rateDisplay,
  setRateDisplay
}: Props) => (
  <SwitchLineInput
    value={rateDisplay === 'PERCENTAGE'}
    onChange={isActive => setRateDisplay(isActive ? 'PERCENTAGE' : 'ABSOLUTE')}
    text="Percentage rates"
    styles={{ label: { color: GreyGrey80, ...Primary13Regular } }}
  />
)
